import { IAdjustmentCategoriesRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetAdjustmentCategoryUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IAdjustmentCategoriesRepositoryResponse> {
    return this.lookupRepository.getAdjustmentCategories();
  }
}

